export default "__VITE_ASSET__tdFMfG5k__"